import React, { useEffect, useCallback } from 'react'
import { Dialog } from 'primereact/dialog'
import './DialogQualtrics.scss'

const DialogQualtrics = (props: {
    surveyUrl: string
    surveyTitle: string
    dialogVisible: boolean
    hideDialog?: boolean
    onHide: () => void
    onSubmit?: (surveyId: string, responseId: string) => void
    onCreateSurveyTask?: (params: Record<string, string>) => void
}) => {
    const {
        surveyUrl,
        surveyTitle,
        dialogVisible,
        hideDialog,
        onHide,
        onSubmit,
        onCreateSurveyTask,
    } = props

    const componentClass = 'smart-modals-dialog-qualtrics'

    const handleSubmit = useCallback(
        (evt) => {
            if (
                typeof evt.data === 'string' &&
                evt.data.match('closeQSIWindow|QualtricsEOS|SV_.*|FS_.*')
            ) {
                const data = evt.data.split('|')
                const surveyId = data[1]
                const responseId = data[2]
                if (onSubmit) {
                    onSubmit(surveyId, responseId)
                }
            }

            try {
                if (evt.data?.includes('visit_id')) {
                    onCreateSurveyTask(JSON.parse(evt.data))
                }
            } catch (e) {
                console.error(e)
            }
        },
        [onSubmit]
    )

    const getSearchParams = (search: string) => {
        const queryString = search.slice(1) // Rimuovi il "?" iniziale
        const params = {}

        if (queryString) {
            const pairs = queryString.split('&')
            for (const pair of pairs) {
                const [key, value] = pair.split('=')
                params[decodeURIComponent(key)] = decodeURIComponent(value || '')
            }
        }

        return params
    }

    useEffect(() => {
        window.addEventListener('message', handleSubmit)
        return () => window.removeEventListener('message', handleSubmit)
    }, [handleSubmit])

    useEffect(() => {
        const handleUrlChange = () => {
            onCreateSurveyTask(getSearchParams(window.location.search))
        }
        if (onCreateSurveyTask) {
            window.addEventListener('popstate', handleUrlChange)
            window.addEventListener('pushState', handleUrlChange)
            window.addEventListener('replaceState', handleUrlChange)
        }

        return () => {
            window.removeEventListener('popstate', handleUrlChange)
            window.removeEventListener('pushState', handleUrlChange)
            window.removeEventListener('replaceState', handleUrlChange)
        }
    }, [])

    return (
        <Dialog
            header={surveyTitle}
            draggable={false}
            visible={dialogVisible}
            onHide={onHide}
            footer={<></>}
            style={{ width: '50vw' }}
            maskClassName={`${componentClass} ${hideDialog ? 'hidden' : ''}`}
            breakpoints={{ '960px': '85vw' }}>
            <iframe width={'100%'} height={'100%'} src={surveyUrl} />
        </Dialog>
    )
}

export default DialogQualtrics
